import { render, staticRenderFns } from "./FilterPVResult.vue?vue&type=template&id=2ceb225b&scoped=true"
import script from "./FilterPVResult.vue?vue&type=script&lang=js"
export * from "./FilterPVResult.vue?vue&type=script&lang=js"
import style0 from "./FilterPVResult.vue?vue&type=style&index=0&id=2ceb225b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceb225b",
  null
  
)

export default component.exports